import { useCallback, useMemo } from 'react';
import {
  getTemplateKey,
  state as reactiveState,
} from '@frameio/graphql-client';
import type { LayoutKey, TemplateStore } from '..';

/**
 * `get` and `set` templates which are stored beyond a users session.
 * This is used on panels within usePanelLayoutState.
 * And is used directly to retrieve template configurations
 * for accordions which can also make up a layout.
 *
 * @param layout - the 'layout' string value
 */
export function useTemplateLayoutState(layoutKey: LayoutKey) {
  const template = useMemo(() => {
    const templateKey = getTemplateKey(layoutKey);
    return reactiveState.templates.templates.get(templateKey);
  }, [layoutKey]);

  const setTemplate = useCallback(
    (nextTemplate: TemplateStore) => {
      const templateKey = getTemplateKey(layoutKey);
      return reactiveState.templates.templates.set(templateKey, nextTemplate);
    },
    [layoutKey]
  );

  return {
    setTemplate,
    template,
  };
}
